<template>
  <section class="contact-form">
    <div class="container">
      <h3 class="contact-form__title title">
        {{ $t("contact_title") }}
      </h3>
      <h4 class="contact-form__subtitle subtitle">
        {{ openingHours }}
      </h4>
      <h4>
        <a
          class="contact-form__link"
          :href="`tel:${owner.company_phone}`"
        >
          {{ owner.company_phone }}
        </a>
      </h4>
      <h4>
        <a
          class="contact-form__link"
          :href="`mailto:${email}`"
        >
          {{ email }}
        </a>
      </h4>
      <!-- Form -->
      <Form
        id="contact-form"
        :action="formUrl"
        method="POST"
        class="row contact-form__form"
        @submit="onSubmit"
        @invalid-submit="invalidSubmit"
      >
        <h3 class="contact-form__title title">
          {{ $t("contact_form_title") }}
        </h3>
        <h4 class="contact-form__subtitle subtitle">
          {{ $t("contact_form_subtitle") }}
        </h4>
        <Input
          :label="$t('contact_name')"
          name="name"
          rules="required"
          classes="contact-form__input-container col-md-6 col-12"
          @updated-value="changeField"
        />
        <Input
          label="Email"
          name="email"
          rules="required"
          classes="contact-form__input-container col-md-6 col-12"
          @updated-value="changeField"
        />
        <Input
          :label="$t('contact_phone')"
          name="phone"
          classes="contact-form__input-container col-md-6 col-12"
          @updated-value="changeField"
        />
        <Input
          :label="$t('contact_count')"
          name="count"
          classes="contact-form__input-container col-md-6 col-12"
          @updated-value="changeField"
        />
        <Textarea
          label="Správa"
          name="message"
          rules="required"
          classes="contact-form__input-container col-12"
          @updated-value="changeField"
        />
        <!-- Button -->
        <button class="comparison__primary-btn primary-btn">
          {{ $t("contact_send") }}
        </button>
      </Form>
    </div>
  </section>
</template>
<script>
import { Form } from 'vee-validate'
import useContactForm from './useContactForm'
import Input from './partials/input/Input.vue'
import Textarea from './partials/input/Textarea.vue'

export default {
  components: {
    Input,
    Textarea,
    Form,
  },
  props: {
    owner: {
      type: Object,
    },
    email: {
      type: String,
    },
    openingHours: {
      type: String,
    },
    formUrl: {
      type: String,
    },
  },
  setup() {
    const {
      changeField, onSubmit, invalidSubmit, data,
    } = useContactForm()

    return {
      changeField,
      onSubmit,
      invalidSubmit,
      data,
    }
  },
}
</script>
